import React from 'react'
import { submitLead, toValuationPayload } from '../api/leadGeneration'
import { getSessionId } from '../lib/session'
import PublicPage from './PublicPage'

function submitValuation(page, form, values) {
  return submitLead(page.publicKey, { ...toValuationPayload(values), sessionId: getSessionId() })
}

function ValuationPage() {
  return <PublicPage onFormSubmit={submitValuation} />
}

export default ValuationPage
